module.exports = __webpack_public_path__ + "img/browse-filter-any-field-overflow-hero-infiniti.cc9aae29.png";